// @flow
import React, { useContext } from 'react';
import {
    injectIntl, defineMessages, IntlShape,
} from 'react-intl';
import { EditorContext } from 'esm-web-pro/containers/map/editor/BaseEditor';
import ReactTooltip from 'react-tooltip';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';
import 'esm-web-pro/styles/control-icon.less';


type Props = {
    intl: IntlShape,
    toggle: Function,
    argument: String,
    show: boolean,
    showIcon: any,
    hideIcon: any,
    disabled?: boolean,
}

const messages = defineMessages({
    showInfo: {
        id: 'networks-map-show-info',
        defaultMessage: 'Show content info',
    },
});

const ShowMapObjectsControl = (props: Props) => {
    const {
        toggle, argument, show, showIcon, hideIcon, intl: { formatMessage }, disabled,
    } = props;

    const editor = useContext(EditorContext);

    const toggleShowContent = (e) => {
        toggle(argument);
        editor._loadFeatures();
    };

    return (
        <div className="leaflet-bar networks-additional-control">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
                href="#"
                title={formatMessage[messages.showInfo]}
                role="button"
                aria-label={formatMessage[messages.showInfo]}
                onClick={!disabled ? toggleShowContent : undefined}
                data-tip
                data-for={`map-show-${argument}-tooltip`}
            >
                <img
                    src={show ? showIcon : hideIcon}
                    alt="content-info-icon"
                    className={disabled ? 'control-icon-disabled' : undefined}
                />
            </a>
            <ReactTooltip
                id={`map-show-${argument}-tooltip`}
                effect="solid"
                place="right"
                className="react-tooltip"
            >
                <LabelText>
                    {show ? formatMessage({
                        id:
                        `map-hide-${argument}`,
                        defaultMessage: `Hide ${argument}`,
                    }) : formatMessage({
                        id:
                            `map-show-${argument}`,
                        defaultMessage: `Show ${argument}`,
                    })}
                </LabelText>
            </ReactTooltip>
        </div>
    );
};

ShowMapObjectsControl.defaultProps = {
    disabled: false,
};

export default injectIntl(ShowMapObjectsControl);
